module.exports = __webpack_public_path__ + "img/no-data.3d533201.svg";